import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { config, encodeBase64RequestBody, nameFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const SubsidiaryEdit = () => {
  const { id_subcompany } = useParams();
  const [ companies, setCompanies ] = useState(null);
  const [ subcompanies, setSubcompanies ] = useState(null);
  const [ companyGroup, setCompanyGroup ] = useState(null);
  const [ subcompanyId, setSubcompanyId ] = useState('');
  const [ subcompanyName, setSubcompanyName ] = useState('');
  const [ subcompanyAddress, setSubcompanyAddress ] = useState('');
  const [ subcompanyBillingName, setSubcompanyBillingName ] = useState('');
  const [ subcompanyBillingAddress, setSubcompanyBillingAddress ] = useState('');
  const [ subcompanyPhone, setSubcompanyPhone ] = useState('');
  const [ subcompanyFax, setSubcompanyFax ] = useState('');
  const [ subcompanyNpwpNumber, setSubcompanyNpwpNumber ] = useState(null);
  const [ subcompanyNpwpFiles, setSubcompanyNpwpFiles ] = useState(null);
  const [ subcompanyNpwpNewFiles, setSubcompanyNpwpNewFiles ] = useState(null);
  const [ subcompanyStatus, setSubcompanyStatus ] = useState(true);
  const [ selectedName, setSelectedName ] = useState(null);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getCompanies();
    getSubcompanies();
  }, []);

  useEffect(() => {
    if (companies) {
      getSubcompany();
    }
  }, [companies]);
  
  useEffect(() => {
    if (selectedName) {
      setSubcompanyName(selectedName.label ? nameFormat(selectedName.label) : '');
    }
  }, [selectedName]);
  
  const changeSubcompanyName = (name) => {
    setSelectedName({
      value: 0,
      label: name,
      isDisabled: false
    });
    setSubcompanyName(name);
  }

  const getSubcompanies = async () => {
    try {
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody({})
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        const subcompanies = [];
        for (let c in responseCompanies.data) {
          subcompanies.push({
            value: responseCompanies.data[c].id_company,
            label: responseCompanies.data[c].company_name,
            isDisabled: true
          });
        }
        setSubcompanies(subcompanies);
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getSubcompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getCompanies = async () => {
    try {
      const requestGetCompanies = {
        "company_status": 'Active'
      };
      const fetchGetCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestGetCompanies)
      });
      const responseGetCompanies = await fetchGetCompanies.json();
      if (responseGetCompanies.status === 200) {
        for (let i in responseGetCompanies.data) {
          responseGetCompanies.data[i].value = responseGetCompanies.data[i].id_company;
          responseGetCompanies.data[i].label = responseGetCompanies.data[i].company_name;
        }
        setCompanies([...responseGetCompanies.data].sort((a, b) => (a.company_name || '').localeCompare(b.company_name || '')));
      } else {
        alert(responseGetCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getSubcompany = async () => {
    try {
      const requestGetSubcompany = {
        id_subcompany: id_subcompany
      };
      const fetchGetSubcompany = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestGetSubcompany)
      });
      const responseGetSubcompany = await fetchGetSubcompany.json();
      if (responseGetSubcompany.status === 200) {
        changeCompanyData(responseGetSubcompany.data[0].company_id);
        setSubcompanyId(responseGetSubcompany.data[0].id_subcompany);
        setSubcompanyName(responseGetSubcompany.data[0].company_name);
        setSubcompanyAddress(responseGetSubcompany.data[0].company_address);
        setSubcompanyBillingName(responseGetSubcompany.data[0].company_billing_name);
        setSubcompanyBillingAddress(responseGetSubcompany.data[0].company_billing_address);
        setSubcompanyPhone(responseGetSubcompany.data[0].company_phone);
        setSubcompanyFax(responseGetSubcompany.data[0].company_fax);
        setSubcompanyNpwpNumber(responseGetSubcompany.data[0].company_npwp_number);
        setSubcompanyNpwpFiles(responseGetSubcompany.data[0].company_npwp_files);
        setSubcompanyStatus(responseGetSubcompany.data[0].company_status === 'Active' ? true : false);
        setSelectedName({
          value: responseGetSubcompany.data[0].id_subcompany,
          label: responseGetSubcompany.data[0].company_name
        });
      }
    } catch (error) {
      console.error('Error in getSubcompany:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const changeCompanyData = (value) => {
    const company = companies.find(company => company.id_company == value);
    setCompanyGroup(company);
  }
    
  const uploadFile = async (formData) => {
    try {
      const responseUploadFile = await jwtFetch(config.ENDPOINT + 'upload/gdrive', {
        method: 'POST',
        body: formData,
      });
      if (!responseUploadFile.ok) {
        throw new Error(`Upload failed with status: ${responseUploadFile.status}`);
      }
      const resultUploadFile = await responseUploadFile.json();
      if (resultUploadFile.status === 200) {
        return resultUploadFile.data;
      } else {
        alert(`Upload error: ${resultUploadFile.message}`);
      }
    } catch (error) {
      console.error('Error in uploadFile:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const removeSubcompanyNpwpFile = async (npwpIndex) => {
    const filesArray = JSON.parse(subcompanyNpwpFiles);
    filesArray.splice(npwpIndex, 1);
    setSubcompanyNpwpFiles(JSON.stringify(filesArray));
  }

  const submitSubcompanyEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      let subcompanyNpwp = null;

      if (subcompanyNpwpFiles) {
        subcompanyNpwp = JSON.parse(subcompanyNpwpFiles);
      }

      if (subcompanyNpwpNewFiles) {
        const formData = new FormData();
        subcompanyNpwpNewFiles.forEach((subcompanyNpwpFile) => {
          formData.append('files', subcompanyNpwpFile);
        });
        const responseUploadFile = await uploadFile(formData);
        if (responseUploadFile) {
          if (subcompanyNpwp) {
            subcompanyNpwp = [...subcompanyNpwp, ...responseUploadFile];
          } else {
            subcompanyNpwp = responseUploadFile;
          }
        }
      }

      const requestSubcompanyEdit = {
        "id_subcompany": subcompanyId,
        "company_id": companyGroup.id_company,
        "company_name": subcompanyName,
        "company_address": subcompanyAddress,
        "company_billing_name": subcompanyBillingName,
        "company_billing_address": subcompanyBillingAddress,
        "company_phone": subcompanyPhone,
        "company_fax": subcompanyFax,
        "company_npwp_number": subcompanyNpwpNumber,
        "company_npwp_files": JSON.stringify(subcompanyNpwp),
        "company_status": subcompanyStatus === true ? 'Active' : 'Inactive'
      };
      const fetchSubcompanyEdit = await jwtFetch(config.ENDPOINT + 'update/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestSubcompanyEdit)
      });
      const responseSubcompanyEdit = await fetchSubcompanyEdit.json();
      if (responseSubcompanyEdit.status === 200) {
        window.location.href = "/client/subsidiary/detail/" + id_subcompany;
      } else {
        alert(responseSubcompanyEdit.message);
      }
    } catch (error) {
      console.error('Error in submitSubcompanyEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div id="subsidiary-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="client"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Company Group Edit</div>
                  <form className="row" onSubmit={(e) => submitSubcompanyEdit(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Group <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={companyGroup} options={companies} placeholder="" onChange={(e) => changeCompanyData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <CreatableSelect options={subcompanies} value={selectedName} placeholder="Type name..." onCreateOption={(e) => changeSubcompanyName(e)} isClearable required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Legal Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={subcompanyBillingName} onChange={(e) => setSubcompanyBillingName(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Billing Address</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" value={subcompanyBillingAddress} onChange={(e) => setSubcompanyBillingAddress(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Mailing Address</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" value={subcompanyAddress} onChange={(e) => setSubcompanyAddress(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Phone Number</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={subcompanyPhone} onChange={(e) => setSubcompanyPhone(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Fax</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={subcompanyFax} onChange={(e) => setSubcompanyFax(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status</label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch">
                            <input id="status" className="form-check-input" type="checkbox" value={true} onChange={() => setSubcompanyStatus(!subcompanyStatus)} checked={subcompanyStatus}/>
                            <label htmlFor="status" className="form-check-label">{subcompanyStatus ? 'Active' : 'Inactive'}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card mb-4">
                        <div className="card-body">
                          <div className="fs-18 mb-3">NPWP</div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Number</label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control" type="text" value={subcompanyNpwpNumber} onChange={(e) => setSubcompanyNpwpNumber(e.target.value)}/>
                            </div>
                          </div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>File</label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control mb-2" type="file" multiple={true} accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => setSubcompanyNpwpNewFiles(Array.from(e.target.files))}/>
                              <div className="d-flex flex-wrap gap-2">
                                {JSON.parse(subcompanyNpwpFiles) && (
                                  JSON.parse(subcompanyNpwpFiles).map((file, s) => 
                                    <div className="d-flex align-items-center justify-content-between w-100" key={"file-" + s}>
                                      <iframe src={file.fileUrl} width="240" height="160" title="Subsidiary NPWP file" />
                                      <button className="btn btn-outline-danger ms-2" type="button" onClick={() => removeSubcompanyNpwpFile(s)}><i className="bi bi-trash"/></button>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/client'}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubsidiaryEdit;


